module.exports = __webpack_public_path__ + "img/threeFingerThrowText3.8591a213.png";